import React from "react";
// import Button from "react-bootstrap/Button";
import { LinkContainer } from 'react-router-bootstrap'
import {Link} from 'util/router'
import { Button, Nav, Navbar, NavDropdown, MenuItem, NavItem } from 'react-bootstrap';


function UserButton({user}) {

    var firstName = ""
    var lastName = ""
    var platformID = ""
    if (user) {
        firstName = user.firstName ?? ""
        lastName = user.lastName ?? ""
        platformID = user.platformID ?? ""
    }
    return (

        <Link to={`/dashboard/clients/` + platformID}>
            {firstName ?? ""}&nbsp;{lastName ?? ""}
            {/* <button
            className="btn btn-link text-left pl-0"
            >
                {firstName ?? ""}&nbsp;{lastName ?? ""}
            </button> */}
        </Link>
    )
}

export default UserButton